var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_vm._v("Belichtingstool "+_vm._s(_vm.versie)+" - "),_c('a',{attrs:{"href":"http://www.thomasmore.be"}},[_vm._v("Kenniscentrum Energie (KCE) - Thomas More Kempen")]),_vm._v(" © 2019-2020")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696b37e0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/nav_components/Footer.vue
// module id = 310
// module chunks = 1